var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryChargingFull300DpFfffffFill0Wght200Grad0Opsz48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M663.08-103.92v-102.23h-52.31l86.15-169.7v102h52.31l-86.15 169.93Zm-316.93-46.85ZM343.08-120q-11.77 0-19.73-7.96-7.97-7.96-7.97-19.73v-612.93q0-11.01 7.97-19.35 7.96-8.34 19.73-8.34h69.23V-840h135.38v51.69h69.39q11.8 0 19.67 8.34 7.87 8.34 7.87 19.35v300.7q-8.31 1.54-16 2.77-7.7 1.23-14.77 3.92v-305.08h-267.7v607.54h128.93q4.95 8.83 10.13 16.38 5.17 7.54 10.71 14.39H343.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryChargingFull300DpFfffffFill0Wght200Grad0Opsz48);
export default __webpack_public_path__ + "static/media/battery_charging_full_300dp_FFFFFF_FILL0_wght200_GRAD0_opsz48.5d1142fd18c9030681867f429b162701.svg";
export { ForwardRef as ReactComponent };